import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

/** Cinematic Editorial-Break im Reel-Stil · Externenprüfung PFA */
export default function CinematicBreak() {
  return (
    <section data-testid="cinematic-break" className="relative min-h-[82vh] flex items-center justify-center overflow-hidden text-center bg-espresso-deep">
      <img
        src="/images/cinema/break-wide.jpg"
        alt=""
        className="absolute inset-0 w-full h-full object-cover kenburns-slow-out"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{ background: "linear-gradient(to bottom, rgba(24,21,18,0.38) 0%, rgba(24,21,18,0.28) 40%, rgba(24,21,18,0.85) 100%)" }}
      />
      <div className="relative px-6 py-24 md:py-28 max-w-4xl">
        <div className="text-[11.5px] uppercase tracking-[0.34em] font-bold text-brand-rose">
          Online-live per Zoom · Keine Warteliste
        </div>
        <div className="w-28 h-px bg-saffron-dark mx-auto mt-6" />
        <h2 className="font-magazine text-cream-50 font-bold leading-[1.06] text-[3rem] sm:text-[4rem] lg:text-[5.2rem] mt-7">
          Start<br />
          <em className="italic text-brand-rose">jeden Montag.</em>
        </h2>
        <p className="mt-8 text-cream-100/90 text-[16px] sm:text-[16.5px] leading-[1.8] max-w-lg mx-auto">
          Externenprüfung Pflegefachassistenz — 300 UE Vorbereitung,
          Prüfungsplätze über unsere Partnerschulen in NRW.
        </p>
        <div className="mt-10 flex flex-wrap items-center justify-center gap-x-6 gap-y-4">
          <Link
            to="/externenpruefung-pflegefachassistenz"
            data-testid="cinematic-break-cta"
            className="inline-flex items-center gap-2.5 rounded-full border-[1.5px] border-brand-rose text-brand-rose hover:bg-brand-rose hover:text-espresso-deep px-9 h-14 text-[12.5px] font-bold uppercase tracking-[0.14em] transition-colors"
          >
            Externenprüfung entdecken <ArrowRight className="h-4 w-4" strokeWidth={2} />
          </Link>
          <span className="font-magazine italic text-[16px] text-cream-100/90">
            2.490 € · Ratenzahlung möglich
          </span>
        </div>
      </div>
    </section>
  );
}
